import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, map, take } from 'rxjs';
import { FeatureFlagService } from './feature-flag.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsState {
  // Will emit to last emitted values to any new subscribers.
  public featureFlags: ReplaySubject<Array<string>> = new ReplaySubject(1);

  constructor(private featureFlagService: FeatureFlagService) {
    this._init();
  }

  private _init(): void {
    this.featureFlagService.getAll().pipe(take(1)).subscribe((featureFlags: Array<string>) => {
      this.featureFlags.next(featureFlags);
    });
  }
  
  public hasFlags(flags: string[]): Observable<boolean> {
    return this.featureFlags.asObservable().pipe(
      map((featureFlags: Array<string> | null) => {
        return flags.every(flag => featureFlags ? featureFlags.includes(flag) : false);
      })
    );
  }

  public getFlags(): Observable<Array<string>> {
    return this.featureFlags.asObservable();
  }
}